import React, { Component, Fragment, useState, useEffect } from 'react'
import {AppsOutlined,
    TrendingUpOutlined, 
    GroupOutlined, 
    TheatersOutlined} from '@material-ui/icons'
import SkelLoad from '../SkeletonLoading'

const Activity = (props) => { // part of HomePage 
    
    
    return(
        <Fragment>
            <div className ="activityWrapper">
             <ul>
                 <li>
                     <div className= "actvityTitle activity">
                         <div className = "act">
                             <div>
                                 <div>
                                     <TrendingUpOutlined style={{color:"green"}}/> &nbsp;Activity
                                 </div>
                             </div>
                         </div>
                     </div>
                    <p>{props.loading == true ? <SkelLoad/> : props.status.activity}</p>
                 </li>
                 <li>
                     <div className= "actvityTitle Projects">
                         <div className = "act">
                             <div>
                                 <div>
                                     <AppsOutlined/> &nbsp;Projects
                                 </div>
                             </div>
                         </div>
                     </div>
                     <p>{props.loading == true ? <SkelLoad/> : props.status.projects}</p>
                 </li>

                 <li>
                     <div className= "actvityTitle Festival">
                         <div className = "act">
                             <div>
                                 <div>
                                     <TheatersOutlined style={{color:"yellow"}} /> &nbsp;Festival Win
                                 </div>
                             </div>
                         </div>
                     </div>
                     <p>{props.loading == true ? <SkelLoad/> : props.status.festivalWin}</p>
                 </li>
                    <li>
                        <div className= "actvityTitle absent">
                            <div className = "act">
                                <div>
                                    <div>
                                        <GroupOutlined style={{color:"red"}} /> &nbsp;Absent
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>{props.loading == true ? <SkelLoad/> : props.status.absent}</p>
                    </li>
                </ul>
            </div>
        </Fragment>
    )
}
export default Activity